const l = {
  name: "Xcode",
  dimensions: { width: 40, height: 35 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 35.1" style="enable-background:new 0 0 40 35.1;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M14.7,33c-0.1-0.2-0.2-0.4-0.3-0.6H6.1c-3.4,0-6.1-2.7-6.1-6.1V8.6c0-3.4,2.7-6.1,6.1-6.1h12.8
			c0.7-0.9,1.6-1.6,2.6-2.1l0,0l0,0c1.4-0.6,3.1-0.6,4.6,0l4.7,1.9l0,0C32.3,3,33.1,4.5,33,6l0.4,0.2c0.8,0.3,1.7-0.1,2-0.8l0.4-0.9
			l2.1,0.9c1.8,0.7,2.7,2.8,1.9,4.6l0,0L38,14.1H38c-0.9,1.4-2.7,1.9-4.3,1.3l0,0l-2.1-0.9l0.4-0.9c0.2-0.4,0.2-0.8,0-1.2l0,0
			c-0.1-0.3-0.4-0.6-0.8-0.8l0,0l-0.2-0.1l-1,2.3l0,0v12.6c0,3.4-2.7,6.1-6.1,6.1h-1.7c-0.4,1.2-1.4,2.2-2.7,2.6
			C17.6,35.5,15.6,34.7,14.7,33L14.7,33z M22.2,2.3c-0.7,0.3-1.3,0.8-1.7,1.4c1.3,0.7,2.4,1.6,3.1,2.6c0.7,0.9,1.2,2.1,1.1,3.2
			l4,1.7l0.1,0l1-2.3l2.1,0.9c0.9,0.4,1.6,1.1,1.9,1.9c0.2,0.5,0.3,1.1,0.2,1.7l0.4,0.2l0,0c0.8,0.3,1.7-0.1,2-0.8l0.3-0.6h0
			l1.2-2.9l0,0c0.3-0.8-0.1-1.7-0.8-2L36.7,7c-1,1.2-2.6,1.7-4.1,1l-2.1-0.9l0.4-0.9c0.3-0.8,0-1.7-0.8-2l0,0l-4.7-1.9
			C24.3,1.9,23.2,1.9,22.2,2.3z M22.2,10.6l0.4-0.9c0.2-0.5,0.1-1.3-0.6-2.2c-0.7-0.9-1.8-1.8-3.3-2.4l-0.9-0.4l0.1-0.1H6.1
			C3.8,4.5,2,6.4,2,8.6v17.7c0,2.2,1.8,4.1,4.1,4.1h8.2c0.1-0.4,0.2-0.8,0.4-1.1l0,0l3.4-7h-6.2l-3,4.6l-1.7-1.1l2.3-3.5H7.3v-2h3.3
			l3.1-4.8L9.7,9.2l1.7-1.1l3.6,5.6l3.6-5.6l1.7,1.1l-4.1,6.4L19,20l4.3-8.9L22.2,10.6z M16.8,20.3l-1.9-2.9l-1.9,2.9H16.8z
			 M27.9,16l-5.1,14.4h1c2.2,0,4.1-1.8,4.1-4.1V16z M16.4,30.1c-0.3,0.6-0.3,1.3,0.1,1.9c0.5,0.9,1.5,1.3,2.4,1l0,0
			c0.7-0.2,1.2-0.7,1.4-1.3l6.7-19.2l-1.8-0.7L16.4,30.1z"/>
	</g>
</g>
</svg>
  `
};
export {
  l as Xcode
};
